import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { initializeSentry } from '@app/shared/utils/sentry';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

initializeSentry(environment);

Sentry.startSpan(
  {
    name: 'bootstrap-angular-application',
    op: 'ui.angular.bootstrap',
  },
  async () => {
    // eslint-disable-next-line no-console
    await bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  },
);
